var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation_layout__container"},[_vm._t("header",function(){return [_c('NavigationBar',{attrs:{"title":_vm.navigationTitle,"navigation-bar-style":_vm.navigationBarStyle}})]}),_c('div',{staticClass:"navigation_layout__contents_wrapper",style:(_vm.navigationContentStyle)},[_vm._t("contents")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }